import React from 'react'
import { Col, Row } from 'react-styled-flexboxgrid'

import TABLE_SIZES from './tableSizeProps'

import Label from '~/components/Form/Label'
import Divider from '~/components/traffic-tickets/steps/Divider'

const TableHeader = () => {
  return (
    <>
      <Row>
        <Col {...TABLE_SIZES.ticketID}>
          <Label>Ticket ID</Label>
        </Col>
        <Col {...TABLE_SIZES.issuedOn}>
          <Label>Issued On</Label>
        </Col>
        <Col {...TABLE_SIZES.amountDue}>
          <Label>Amount Due</Label>
        </Col>
        <Col {...TABLE_SIZES.evidence}>
          <Label>Evidence</Label>
        </Col>
      </Row>
      <Divider top={10} bottom={10} />
    </>
  )
}

export default TableHeader